import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../CoustamComponent/Header";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage } from "../../../Services/CustomAlertModel";
import { ProfileContext } from "../../../Services/ProfileProvider";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";

const CopyTrading = () => {

	const [masterData, setMasterData] = useState([]);
	const [filterKey, setFilterKey] = useState('');
	const [experties, setExperties] = useState('');

	const [searchTerm, setSearchTerm] = useState('');
	const navigate = useNavigate();

	const { wlletBalance, userDetails } = useContext(ProfileContext);
	const KycStatus = userDetails?.kycVerified;
	const location = useLocation();


	const formatNumer = (number) => {
		return new Intl.NumberFormat('en-US').format(number);
	}

	const handleMasterListing = async () => {
		try {
			const result = await AuthService.masterListing();
			if (result?.success) {
				setMasterData(result?.data?.reverse());
			} else {
				alertErrorMessage(result?.message);
			}
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleSearch = (data) => {
		return data.filter(item => {
			const matchesSearchTerm = item.masters_name?.toLowerCase().includes(searchTerm?.toLowerCase());
			const matchesExperties = experties ? item.master_trader_experitse === experties : true;
			return matchesSearchTerm && matchesExperties;
		});
	};

	const handleSorting = (data) => {
		switch (filterKey) {
			case 'Risk Score':
				return [...data].sort((a, b) => b.masters_risk_score - a.masters_risk_score);
			case 'Top Gainers':
				return [...data].sort((a, b) => b.totalGain - a.totalGain);
			case 'Most Popular':
				return [...data].sort((a, b) => b.masters_copier - a.masters_copier);
			default:
				return data;
		}
	};

	const sortedMasterData = handleSorting(masterData);
	const filteredData = handleSearch(sortedMasterData);

	useEffect(() => {
		handleMasterListing();
	}, []);

	const nextPage = (item) => {
		navigate("/trader_details", { state: item });
	};

	const [hoveredId, setHoveredId] = useState(null);

	const handleMouseEnter = (id) => {
		setHoveredId(id);
	};

	const handleMouseLeave = () => {
		setHoveredId(null);
	};


	return (
		<div className="wrapper saprate_page container-responsive">
			<div className="page-body ">
				<div className="page-wrap">

					<Header />

					<div className="page_wrapper">
						<div className="ct-header__top">
							<div className="container">
								<div className="ct-header__inner d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">
									<h2 className="ct-header__name text-center text-lg-start">
										Copy Trading
									</h2>
									<div className="ct-header__wallet mt-3 mt-lg-0">
										<div className="ct-wallet d-flex flex-column flex-lg-row align-items-lg-center">
											<div className="ct-wallet__balance text-center text-lg-start">
												<div className="ct-wallet__head"> Wallet balance </div>
												<div className="ct-wallet__count">
													<div className="ct-wallet__count-int"> ${formatNumer(wlletBalance?.balance?.toFixed(2) || 0)} </div>
												</div>
											</div>
											{KycStatus === 2 &&
												<div className="ct-wallet__nav mt-3 mt-lg-0 ms-lg-3">
													<Link to="/withdraw" className="ct-wallet__withdrawal btn btn-primary-light btn-sm me-2">
														Withdrawal
													</Link>
													<Link to="/deposit" className="ct-wallet__deposit btn btn-primary btn-sm">
														Deposit
													</Link>
												</div>
											}
										</div>
									</div>
								</div>

								<div className="page_tabs mt-4">
									<div className="nav nav-tabs justify-content-center justify-content-lg-start" id="nav-tab" role="tablist">
										<Link className={`nav-link ${location?.pathname === "/copy_trading" && "active"}`} id="nav-Rating-tab" to="/copy_trading">Rating</Link>
										<Link className={`nav-link ${location?.pathname === "/copier_area" && "active"}`} id="nav-Copier-tab" to={KycStatus === 2 ? "/copier_area" : "/update_kyc"}>Copier Area</Link>
										<Link className={`nav-link ${location?.pathname === "/terms_conditions" && "active"}`} id="nav-tandc-tab" to="/terms_conditions">Terms & Conditions</Link>
									</div>
								</div>
							</div>
						</div>

						<div className="page_wrapper">
							<div className="tab-content container" id="nav-tabContent">
								<div className="tab-pane fade show active" id="nav-Rating" role="tabpanel" aria-labelledby="nav-Rating-tab">

									<div className="master_rating">

										<div className="card">
											<div className="card-body">
												<h3>
													Master Rating
												</h3>


												<div className="filter_tabs filter-card">
													<div className="row g-2 align-items-end">
														<div className="col-lg-6">
															<div className="row g-3 ">
																<div className="col-lg-5 col-md-6">
																	<div className="form-group">
																		<label> Whom to Show First </label>
																		<select className="form-control form-select" value={filterKey}
																			onChange={(e) => setFilterKey(e.target.value)}>
																			<option value="Risk Score">Risk Score</option>
																			<option value="Top Gainers">Top Gainers</option>
																			<option value="Most Popular">Most Popular</option>
																		</select>
																	</div>
																</div>

																<div className="col-lg-5 col-md-6">
																	<div className="form-group">
																		<label>Master Trader Expertise</label>
																		<select className="form-control form-select" value={experties}
																			onChange={(e) => setExperties(e.target.value)}>
																			<option value="">Select Expertise</option>
																			<option value="High Achiever">High Achiever</option>
																			<option value="Legend">Legend</option>
																			<option value="Expert">Expert</option>
																			<option value="Growing Talent">Growing Talent</option>
																		</select>
																	</div>
																</div>
															</div>
														</div>
														<div className="col-lg-6">
															<div className="filter_right">

																<div className="filter_search">
																	<div className="input-relative">
																		<input
																			type="search"
																			className="form-control"
																			placeholder="Search"
																			value={searchTerm}
																			onChange={(e) => setSearchTerm(e.target.value)}
																		/>
																		<span><i className="ri-search-line"></i></span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>

												<div className="data_row d-flex flex-column flex-md-row justify-content-between align-items-center mt-3">
													<p className="mb-0">{masterData?.length} Master Traders shown</p>
													<button className="btn btn-link p-0" type="button" onClick={() => {
														setFilterKey("");
														setSearchTerm("");
														setExperties("");
													}}> RESET ALL</button>

												</div>

												<div className="list_view forPadding mt-3">
													<div className="table_data table-responsive">
														<table className="table">
															<thead>
																<tr>
																	<th> </th>
																	<th className="text-end">
																		<span>Risk score<br /><small>All time</small></span>
																	</th>
																	<th className="text-end">
																		<span>Gain<br /><small>All time</small></span>
																	</th>
																	<th className="text-end">
																		<span>Profit and Loss<br /><small className="text-center">All time</small></span>
																	</th>
																	<th className="text-center">
																		<span>Copiers<br /><small>All time</small></span>
																	</th>
																	<th className="text-center">
																		<span>Commission</span>
																	</th>
																</tr>
															</thead>
															<tbody>
																{
																	filteredData?.length > 0 ?
																		filteredData.map((item, index) => {
																			return (
																				<tr className="alt" key={index} onClick={() => nextPage(item)}>
																					<td>
																						<span className="tr_profile cursor-pointer" >
																							<img className="tr_img img-fluid" src={ApiConfig?.url + item?.master_image || "/assets/images/NEWUSER.jpeg"} alt="" onError={(e) => {
																								e.target.onerror = null;
																								e.target.src = "/assets/images/NEWUSER.jpeg";
																							}} />
																							<div className="tr_text" onMouseEnter={() => handleMouseEnter(item?.masterId)}
																								onMouseLeave={handleMouseLeave}>
																								<span>{item?.masters_name}</span>
																								<p className=" mb-0 position-relative archiver_text" >

																									{
																										item?.master_trader_experitse === "Legend" ?
																											<i className="ri-star-smile-line text-success"></i>
																											:

																											item?.master_trader_experitse === "Expert" ?
																												<i className="ri-bard-fill text-success"></i>
																												:
																												item?.master_trader_experitse === "High Achiever" ?
																													<i className="ri-bard-line text-success"></i>
																													:
																													item?.master_trader_experitse === "Growing Talent" ?
																														<i className="ri-bard-line text-success"></i>
																														:
																														<i className="ri-star-half-fill"></i>

																									}



																									{item?.master_trader_experitse}
																									{hoveredId === item?.masterId && (
																										<div className="hover_card">
																											<h6>Master Trader's expertise</h6>
																											<p>The expertise depends on how long the master trader trades with us, how many trades they have made, and what volume they've made.</p>
																											<ul>
																												<li className={item?.master_trader_experitse === "Legend" ? "text-green" : "text-muted"}>
																													<i className={`ri-star-smile-line ${item?.master_trader_experitse === "Legend" ? "text-green" : "text-muted"}`}></i>
																													Legend
																												</li>
																												<li className={item?.master_trader_experitse === "Expert" ? "text-green" : "text-muted"}>
																													<i className={`ri-bard-fill ${item?.master_trader_experitse === "Expert" ? "text-green" : "text-muted"}`} ></i>
																													Expert
																												</li>
																												<li className={item?.master_trader_experitse === "High Achiever" ? "text-green" : "text-muted"}>
																													<i className={`ri-bard-line ${item?.master_trader_experitse === "High Achiever" ? "text-green" : "text-muted"}`}></i>
																													High Achiever
																												</li>
																												<li className={item?.master_trader_experitse === "Growing Talent" ? "text-green" : "text-muted"}>
																													<i className={`ri-star-half-fill ${item?.master_trader_experitse === "Growing Talent" ? "text-green" : "text-muted"}`} ></i>
																													Growing Talent
																												</li>
																											</ul>
																										</div>
																									)}
																								</p>
																							</div>
																						</span>
																					</td>
																					<td className={`text-end ${item.masters_risk_score >= 1 && item.masters_risk_score <= 2
																						? 'text-success'
																						: item.masters_risk_score >= 3 && item.masters_risk_score <= 4
																							? 'text-warning'
																							: 'text-danger'
																						}`}>
																						<span className={`badge ${item.masters_risk_score >= 1 && item.masters_risk_score <= 2
																							? 'bg-green'
																							: item.masters_risk_score >= 3 && item.masters_risk_score <= 4
																								? 'bg-warning'
																								: 'bg-danger'
																							}`} > {item.masters_risk_score} risk  </span>
																					</td>
																					<td className={`text-end ${item.totalGain > 0 ? 'text-success' : ''}`}>
																						{item.totalGain > 0 ? `+${Number(item?.totalGain)?.toFixed(2)}%` : `${Number(item.totalGain)?.toFixed(2)}%`}

																					</td>
																					<td className="text-center">
																						<div className="pandl_row" >
																							<div className="d-flex flex-lg-row flex-column align-items-center justify-content-lg-between" >
																								<span>${item?.totalProfit?.toFixed(2)}</span>
																								<span>${item?.totalLoss?.toFixed(2)} </span>
																							</div>
																							<div className="risk_progress" >
																								<em className="risk_gain" style={{
																									width: `${(item?.totalProfit / (item?.totalProfit + item?.totalLoss)) * 100 || 0}%`
																								}} ></em>
																								<em className="risk_loss" style={{
																									width: `${(item?.totalLoss / (item?.totalProfit + item?.totalLoss)) * 100 || 0}%`
																								}} ></em>
																							</div>
																						</div>
																					</td>
																					<td className="text-center">
																						<div className="d-flex flex-lg-row flex-column align-items-center justify-content-lg-center  gap-2">
																							<span>{item.masters_copier || 0}</span>
																							<span className="d-flex flex-lg-row flex-column align-items-center justify-content-lg-center text-success">
																								<i className="ri-arrow-up-line ms-2 mb-1"></i>
																								<span className="ms-2">
																									{item?.masters_new_copier_count < 0
																										? Math.abs(item.masters_new_copier_count)
																										: item.masters_new_copier_count}
																								</span>
																							</span>
																						</div>
																					</td>

																					<td className="text-center">{item.masters_commissions || 0}%</td>
																				</tr>
																			);
																		})
																		: <tr><td colSpan="6" className="text-center">No Data Found</td></tr>
																}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	);
};

export default CopyTrading;
